import { API_ROUTES, API_URL, DBF_API_URL } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class IntegrationService extends AxiosBase {
  getIntegrationData = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.INTEGRATION}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getOrgIntegrationData = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.GET_ORG_INTEGRATION}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  removeIntegration = async (name, navigate) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.INTEGRATION.REMOVE_INTEGRATION}${name}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  updateIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.INTEGRATION.UPDATE_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateJiraProject = async (projectName, navigate) => {
    try {
      const response = await this.requests.patch(
        `${API_ROUTES.INTEGRATION.UPDATE_JIRA_PROJECT}/${projectName}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  }
  
  sendKekaIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.KEKA_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  sendDBFIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.DBF_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  //DBF Google SSO
  sendDBFGoogleSSO = async (navigate) => {
    try {
      const ssoUrl = `${DBF_API_URL}/api/Token/GoogleLogin?redirect_uri=${API_URL}/api/v1/integration/dbf/callback`;
      window.location.href = ssoUrl; // Redirect the user to start SSO
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  sendOdooIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.ODOO_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  sendSelfbestIntegration = async (navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.SELFBEST_INTEGRATION}`,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  sendTelegramIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.TELEGRAM_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  activateIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.INTEGRATION.ACTIVATE_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  activateIntegrationTelegram = async (body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.INTEGRATION.ACTIVATE_INTEGRATION_TELEGRAM}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  activatetWhatsappIntegration = async (body, navigate, organizationId) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.INTEGRATION.ACTIVATE_INTEGRATION_WHATSAPP}/${organizationId}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getDawrwinBoxApi = async (employeeId, body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.DARWINBOX}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  whatsappIntegrationApi = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.WHATSAPP_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getappMarketPlaceData = async () => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.APP_MARKET_PLACE}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getOrganisationWiseIntegrations = async (page = 1, limit = 10, organisationName = "") => {
    try {
      let url = `${API_ROUTES.INTEGRATION.ORGANISATION_WISE_INTEGRATIONS}?page=${page}&limit=${limit}`;
      if (organisationName && organisationName.trim()) {
        url += `&organisationName=${encodeURIComponent(organisationName.trim())}`;
      }
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getAppsIntegrationRequests = async () => {
    try {
      const response = await this.requests.get(
        API_ROUTES.INTEGRATION.GET_APPS_INTEGRATION_REQUESTS
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateOrgIntegrations = async (orgId, body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.UPDATE_ORG_INTEGRATIONS}/${orgId}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  createApp = async (formData) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.CREATE_APP}`,
        formData
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateApp = async (appId, formData) => {
    try {
      const response = await this.requests.patch(
        `${API_ROUTES.INTEGRATION.UPDATE_APP}/${appId}`,
        formData
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateAdminIntegrations = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.UPDATE_ADMIN_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getYourApps = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.GET_YOUR_APPS}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getAdminAppsMarketplace = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.GET_ADMIN_APPS_MARKETPLACE}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  requestAppsMarketplaceEnable = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.ADMIN_APPS_MARKETPLACE_REQUEST}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getOrgApps = async (navigate) => {
    try {
      // This calls /api/v1/admin/apps endpoint
      const endpoint = `${API_ROUTES.INTEGRATION.GET_ORG_APPS}`;
      console.log("getOrgApps calling endpoint:", endpoint); // Debug log
      const response = await this.requests.get(endpoint);
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  updateAdminIntegration = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.INTEGRATION.UPDATE_ADMIN_INTEGRATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

   getAppCategory = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.INTEGRATION.GET_CATEGORY}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
